import styled from 'styled-components'

import { fontSizes, fontWeights } from '@/styles'
import CdnImage from '@/components/cdn-image'

const BrokerContainer = styled.div`
  display: flex;
  align-items: center;
  ${props =>
    props.direction &&
    `
    flex-direction: ${props.direction};
  `}
`

const BrokerSize = styled.div`
  ${props =>
    props.margins &&
    `
    margin: 25px 50px 0;
  `}
`

const BrokerName = styled.span`
  font-size: ${fontSizes.regular};
  word-break: break-word;
  ${props =>
    props.textAlign &&
    `
    text-align: ${props.textAlign};
  `}
  ${props =>
    props.bold &&
    `
    font-weight: ${fontWeights.medium};
  `}
`

const LogoContainer = styled.div`
  position: relative;
  ${props =>
    props.maxHeight &&
    `
    height: ${props.maxHeight}px;
  `}
  ${props =>
    props.maxWidth &&
    `
    width: ${props.maxWidth}px;
  `}
  display: flex;
  justify-content: center;
  align-items: center;
  ${props => props.align === 'left' && `margin-right: auto;`}
  ${props => props.align === 'right' && `margin-left: auto;`}
  ${props =>
    props.isColumn
      ? `
    margin-bottom: ${props.spacing};
  `
      : `
    margin-right: ${props.spacing};
  `}
`

const BrokerInfo = ({
  broker,
  margins,
  bold,
  maxWidth = 100,
  maxHeight = 75,
  direction = 'column',
  align = 'center',
  textAlign = 'center',
  spacing: initialSpacing,
  ...rest
}) => {
  const isColumn = direction === 'column'
  const spacing = initialSpacing || (isColumn ? '25px' : '15px')
  const logo = broker?.logo?.location || broker?.logo
  if (!broker?.name) return null
  return (
    <BrokerSize {...rest} margins={margins}>
      <BrokerContainer direction={direction}>
        {!!logo && (
          <LogoContainer
            maxHeight={maxHeight}
            maxWidth={maxWidth}
            isColumn={isColumn}
            spacing={spacing}
            align={align}
          >
            <CdnImage
              src={logo}
              sizes={`${maxWidth}px`}
              layout="fill"
              placeholder="blur"
              objectFit="contain"
              alt={`${broker.name || 'Broker'} Logo`}
            />
          </LogoContainer>
        )}
        {!!broker.name && (
          <BrokerName textAlign={textAlign} bold={bold}>
            {broker.name}
          </BrokerName>
        )}
      </BrokerContainer>
    </BrokerSize>
  )
}

export default BrokerInfo
